import './DesktopViewport.scss';

import React from 'react';
import Sidebar from '../sidebar/Sidebar';
import MapView from '../map/mapview/MapView';

export interface DesktopViewportProps {
  readonly googleMapsApiKey: string;
}

function DesktopViewport({ googleMapsApiKey }: DesktopViewportProps) {
  return (
      <main className="fr-desktop">
        <Sidebar/>
        <MapView googleMapsApiKey={googleMapsApiKey}/>
      </main>
  );
}

export default DesktopViewport;
